import * as tslib_1 from "tslib";
import { Tag } from '../../shared/models/tag.model';
/**
 * Tag that associates additional information with an airport.
 */
var AirportTag = /** @class */ (function (_super) {
    tslib_1.__extends(AirportTag, _super);
    function AirportTag() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Parses tag
     * @param data {any} Tag as returned by API
     * @return {Tag} Parsed tag
     */
    AirportTag.parse = function (data) {
        var tag = Tag.parse(data);
        return Object.assign(tag, {
            aptTagId: data.aptTagId,
            airportId: data.airportId,
            sourceId: data.sourceId
        });
    };
    return AirportTag;
}(Tag));
export { AirportTag };
